export default "/images/left_arrow.png?c8b77d946340f21b6a2e95d795c76a2f";